import {
  ProductOptionsContainer,
  ProductOptionsRow,
  ProductsOptionsHeader,
  Label
} from '../ProductOptions/ProductOptions.styles'
import Counter from '../Counter'
import { IProductPackages } from './ProductPackages.types'

const ProductPackages = ({
  packages,
  removeFromCart,
  addToCart,
  disabledActions,
  packageTexts: { description, listLabel, productNoAvailable },
  product
}: IProductPackages) => {
  const renderDescription = () => {
    return <span className="header-texts">{description}</span>
  }
  const { sku, package: productPackage } = product
  return (
    <ProductOptionsContainer>
      <ProductsOptionsHeader>
        <span className="header-texts">{listLabel}</span>
        {renderDescription()}
      </ProductsOptionsHeader>
      {packages.map(
        ({
          name,
          label,
          suffix,
          value,
          quantity,
          jumpQty,
          stock,
          outOfStock = false,
          maxQty
        }) => {
          const labeling = `${label} (${quantity})${suffix ? ` - ${suffix}` : ''}`
          const counterStep = jumpQty || 1
          return (
            <ProductOptionsRow key={name} hideCounter={outOfStock}>
              <Label>{labeling}</Label>
              {!outOfStock && (
                <Counter
                  data={{ name, sku, package: productPackage }}
                  value={value || 0}
                  stock={stock}
                  step={counterStep}
                  disabledActions={disabledActions}
                  plusButton={{
                    actions: addToCart
                  }}
                  minusButton={{
                    actions: removeFromCart
                  }}
                  max={maxQty}
                />
              )}
              {outOfStock && (
                <Label className="text-on-disabled" variant="caption">
                  {productNoAvailable}
                </Label>
              )}
              <span className="overlay" />
            </ProductOptionsRow>
          )
        }
      )}
    </ProductOptionsContainer>
  )
}

export default ProductPackages
